export default class qrData {
    SrNo = '';
    Qrdata = '';
}